<template>
  <div
    v-if="isError"
    class="poster"
    :style="`background: linear-gradient(270.23deg, #26262E 0.15%, #4D4D59 99.76%);${genuine === '3' ? 'height:100vh': ''}`"
  >
    <div class="water-mark" v-watermark="watermarkConfig"></div>
    <div class="bodydiv" :style="`padding-bottom: 27px;`">
      <div class="ccic-top">
        <img :src="header" alt="" />
      </div>
      <div class="top-desc" style="padding:0 10px">
        <img
          class="back-img"
          :style="`${isPcFlag ? 'height:500px;' : 'height:290px;'} width:100%; position:absolute;top:0px;`"
          src="https://oss.turingsenseai.com/1628672040888830257.png"
          alt=""
        />
        <div class="desc_title">
          <img
            src="https://oss.turingsenseai.com/1628567763071957991.png"
            alt=""
          />
        </div>

        <div
          style="width:100%;background:#fff;z-index:100;margin:10px;padding:10px;padding-bottom:0px;margin-bottom: 0px"
        >
          <div
            class="desc_result"
            style="margin-top:10px;font-size: 22px;height:28px;"
          >
            <img
              v-if="!ifFake"
              :style="
                `${
                  isPcFlag
                    ? 'left: 90px;top:-5px;width:40px;height:40px;'
                    : 'left: 50px;width:30px;'
                }`
              "
              src="https://oss.turingsenseai.com/1636169063053922858.png"
            />
            <img
              v-else
              :style="
                `${
                  noAppraisal
                    ? isPcFlag
                      ? 'left: 85px;width: 30px;width:45px;height:45px;top:-8px;'
                      : 'left: 50px;width: 30px;'
                    : isPcFlag
                    ? 'left: 60px;width: 30px;width:45px;height:45px;top:-8px;'
                    : 'left: 35px;width: 30px;'
                }`
              "
              src="https://oss.turingsenseai.com/1636167083823129638.png"
            />
            <p
              :style="{
                'font-size': isPcFlag ? '40px' : '22px',
                'line-height': '32px',
              }"
            >
              {{
                noAppraisal
                  ? ifFake
                    ? "鉴别不通过"
                    : "鉴别为正品"
                  : "无法鉴别"
              }}
            </p>
          </div>

          <div class="desc_container">
            <div class="desc_info">
              <div class="info_item">
                <div>
                  <span>鉴别品牌</span>
                  <p>{{ brandName }}</p>
                </div>
                <br />
                <div>
                  <span>鉴别编号</span>
                  <p style="display:flex;align-items:end;">{{ OAID }}</p>
                </div>
              </div>
              <div class="info_img">
                <img :src="noAppraisal ? (ifFake ? bb : aa) : cc" />
                <div class="img_mark"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="bus_info" :style="`${isPcFlag ? 'width:100%;' : 'width:100%;'}padding-bottom:10px;`">
          <img
            v-if="genuine === '1'" 
            :style="`${isPcFlag ? 'width:95%;' : 'width:95%;'}margin-left: 12px;`"
            src="https://oss.turingsenseai.com/1639114726774693242.png"
            alt=""
          />

          <img
            v-if="genuine === '2' || genuine === '3'" 
            :style="`${isPcFlag ? 'width:95%;' : 'width:95%;'}margin-left: 12px;`"
            src="https://oss.turingsenseai.com/1636022280867380131.png"
            alt=""
          />
        </div>
        <div v-if="noAppraisal" class="bottom-detail">
        <div class="detail_title">
          <h3>细节检测</h3>
        </div>
        <div class="detail_container">
          <van-tabs animated class="tabs">
            <van-tab
              title-style="position: relative; z-index:6;wi"
              v-for="(item, index) in SARecordList"
              :key="index"
              :title="item.pointName"
            >
              <div v-if="item.pointName" class="point_content">
                <div class="precent">
                  <div>
                    <span
                      class="position_text"
                      :style="
                        `left: ${parseInt(
                          (item.grade * 100).toFixed()
                        )}%; transform: scale(0.9) translateX(-${
                          parseInt((item.grade * 100).toFixed()) >= 50 ? 89 : 10
                        }%);`
                      "
                      >符合度{{ parseInt((item.grade * 100).toFixed()) }}%</span
                    >
                    <span
                      class="position"
                      :style="
                        `font-size: 1pt;transform: translateY(-9px);left: ${parseInt((item.grade * 100).toFixed())}%`
                      "
                    ></span>
                  </div>
                  <div class="linear"></div>
                  <div class="precent_tip" style="font-size: 11px;">
                    <span>0% 仿品</span><span>100% 正品</span>
                  </div>
                </div>
                <div
                  class="ponit_pic"
                  :style="
                    ifFake && item.fakePoints.length > 0
                      ? 'justify-content: space-between;'
                      : 'justify-content: center;'
                  "
                >
                  <div
                    :class="
                      ifFake && item.fakePoints.length > 0 ? 'picT' : 'trueP'
                    "
                  >
                    <img
                      :src="item.image"
                      :class="
                        ifFake && item.fakePoints.length > 0 ? '' : 'truePic'
                      "
                      alt=""
                    />
                    <div
                      :class="
                        ifFake && item.fakePoints.length > 0
                          ? 'pic_markF'
                          : 'pic_markT'
                      "
                    >
                      <img
                        v-if="
                          ifFake && item.fakePoints.length > 0 ? false : true
                        "
                        :class="
                          ifFake && item.fakePoints.length > 0
                            ? 'trueArea'
                            : 'trueArea'
                        "
                        ref="detectionBox"
                        src="https://oss.turingsenseai.com/15952947223287.png"
                        :style="
                          `left:${item.detectionBox.x *
                            ((isPcFlag ? 300 * 1.5 : screenWidth * 0.8 * 0.5) /
                              item.originalBox.width)}px;
                          top:${item.detectionBox.y *
                            ((isPcFlag ? 300 * 1.1: screenWidth * 0.83 * 0.6) /
                              item.originalBox.height)}px;
                          width:${item.detectionBox.width *
                            ((isPcFlag ? 300 * 1.2: screenWidth * 0.9 * 0.7) /
                              item.originalBox.width)}px;
                          height:${item.detectionBox.height *
                            ((isPcFlag ? 300 * 1.1 : screenWidth * 0.9 * 0.6) /
                              item.originalBox.height)}px;object-fit: fill;`
                        "
                      />

                      <img
                        v-else
                        :class="
                          ifFake && item.fakePoints.length > 0
                            ? 'trueArea'
                            : 'trueArea'
                        "
                        class="ssss"
                        ref="detectionBox"
                        src="https://oss.turingsenseai.com/15952947223287.png"
                        :style="
                          `left:${item.detectionBox.x *
                            ((isPcFlag ? 260 * 1.1 : screenWidth * 0.7 * 0.5) /
                              item.originalBox.width)}px;
                          top:${item.detectionBox.y *
                            ((isPcFlag ? 230 : screenWidth * 0.68 * 0.6) /
                              item.originalBox.height)}px;
                          width:${item.detectionBox.width *
                            ((isPcFlag ? 260 * 1 : screenWidth * 0.83 * 0.5) /
                              item.originalBox.width)}px;
                          height:${item.detectionBox.height *
                            ((isPcFlag ? 260 * 1 : screenWidth * 0.75 * 0.5) /
                              item.originalBox.height)}px;
                          object-fit: fill;`
                        "
                      />
                    </div>
                    
                    <p>原图</p>
                  </div>
                  <div v-if="ifFake && item.fakePoints.length > 0" class="picF">
                    <img :src="item.croppedImageURL" alt="" />
                    <!-- <div
                      v-for="(item, index) in item.fakePoints"
                      :key="index"
                      class="fake_mark"
                      :style="`left:${item.x / 1.5}px;top:${item.y / 1.6}px;`"
                    ></div> -->
                    <!-- 红点热区修改比例即可 -->
                    <div
                      :class="
                        ifFake && item.fakePoints.length
                          ? 'pic_markF'
                          : 'pic_markT'
                      "
                    ></div>
                    <p>偏假区域</p>
                  </div>
                </div>
                <div class="point_dsc">
                  <p>
                    {{ item.description }}
                  </p>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </div>
        <div v-else class="cant_indt">
          <div
            class="no_title"
            style="line-height: 25px;margin: 15px 0 6px 16px;font-size: 18px;"
          >
            无法鉴别的常见原因
          </div>
          <div
            class="reason"
            style="font-size: 12px;line-height: 17px;margin-bottom: 16px;margin-left:16px;"
          >
            <p>1. 图片清晰度较低;</p>
            <p>2. 拍摄鉴定点位置不正确;</p>
            <p>3. 鉴定点变形等</p>
          </div>
        </div>
      </div>
      <!-- 单鉴结果展示与否通过noAppraisal控制 -->
      
    </div>
    <div style="height:100px;width:100vw"></div>
    <van-popup
      :class="clientWidth > 500 ? 'boswer_poster' : 'poster'"
      v-model="show"
      position="bottom"
      :lock-scroll="true"
      :lazy-render="false"
      closeable
      @opened="savePic"
      :style="{
        height: '70vh',
        width: clientWidth > 500 ? '575px' : '',
        overflow: 'hidden',
      }"
    >
      <div class="pc-mark" v-show="pcMark"><van-loading /></div>
      <div class="poster_title">
        <span>保存到相册</span>
      </div>
      <!-- <vue-canvas-poster
        :widthPixels="0"
        :painting="painting"
        @success="success"
        @fail="fail"
      ></vue-canvas-poster> -->
      <div
        class="poster_container"
        style="width:100%;height:100%;justify-content: center;display:flex;margin-top:20px"
      >
        <img
          v-if="posterPic"
          style="height:416px;width:220px;-webkit-touch-callout: none;"
          :src="posterPic"
          alt=""
        />
      </div>
      <van-button
        style="position: fixed;bottom:0px;"
        class="save"
        type="primary"
        size="large"
        @click="download"
        >点击或长按保存图片</van-button
      >
    </van-popup>

    <div
      v-if="!ifFake"
      class="share"
      :style="`height: 89px;${isPcFlag ? 'width: 100vw;' : ''}`"
      @click="show = !show"
    >
      <span style="margin-top: 10px;height: 40px;line-height: 40px;"
        >保存海报</span
      >
    </div>
    <div
      v-if="isPcFlag ? false : true"
      style="width:100vw;height:100%;position: absolute;top:0;z-index:9999;background-color:#4C4C4C;opacity: 0.8;display: flex;justify-content: center;align-items: center;"
      :style="saveLoading ? '' : 'display:none;'"
    >
      <van-loading size="60px" />
    </div>
    <div id="zp-report-qrcode" style="display:none"></div>
  </div>
</template>

<script>
import "@/common/js/watermark.js";
import bg0 from "@/assets/images/ccic-picture/ccic.png";
// import bg2 from "@/assets/images/appraisal/header.png";
import bg1 from "@/assets/images/appraisal/ai.png";
// import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";
import { HOST_ADDRESS } from "../../../common/constant";
import { fetchWpReportDetail } from "@/common/api/appraisal.js";
// import * as htmlToImage from "html-to-image";
// import { saveAsPng, saveAsJpeg } from "save-html-as-image";

// http://localhost/#/zp-report/AI9V6I11

export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      eleLoading: false,
      saveLoading: false,
      pcMark: false,
      ccic: bg0,
      ai: bg1,
      header: "https://oss.turingsenseai.com/1633945620360284110.png",
      isError: false,
      clientWidth: "",
      imgData: "",

      // 组件
      watermarkConfig: {
        // AIGJXGAJ
        //水印
        text: "图灵鉴定",
        font: "16px 微软雅黑",
        textColor: "rgba(255,255,255,0.2)",
        width: 170, //水印文字的水平间距
        height: 60, //水印文字的高度间距（低于文字高度会被替代）
        extRotate: -30, //-90到0， 负数值，不包含-90
      },
      watermarkConfig1: {
        // AIGJXGAJ
        //水印
        text: "图灵鉴定",
        font: "16px 微软雅黑",
        textColor: "rgba(255,255,255,0.2)",
        width: 120, //水印文字的水平间距
        height: 60, //水印文字的高度间距（低于文字高度会被替代）
        extRotate: -30, //-90到0， 负数值，不包含-90
      },
      showMore: true,
      descList: [],

      // 获取数据
      isAI: false,
      ifFake: false, // 是否符合
      noAppraisal: false,
      kindName: "",
      brandName: "",
      seriesName: "",
      description: "",
      genuine: null,
      descriptionList: [],
      exteriorUrl: "", // 外观图片URL
      appraisalTime: [],
      SARecordList: [], // 详情鉴定列表
      precent: 0,
      OAID: "",
      fakePoints: [],
      exteriorUrlList: [],
      qrcode: "",
      // 弹出层
      show: false,
      backBase64: "",
      exteriorBase64: "",
      screenWidth: document.documentElement.clientWidth, //屏幕宽度
      screenHeight: document.documentElement.clientHeight, //屏幕宽度
      DBwidth: "",
      // 海报图片
      posterPic: "",
      isPosterPic: true,
      isPcFlag: "",
      Flag: true,
      openError: false,
      aa: "https://oss.turingsenseai.com/1628575872053959757.png",
      bb: "https://oss.turingsenseai.com/1628679598180643073.png",
      cc: "https://oss.turingsenseai.com/1628582036592914079.png",
      painting: {},
    };
  },
  methods: {
    // success(src) {
    //   this.posterPic = src;
    // },
    fail(err) {
      console.log(err);
    },
    getImageDataURL(image) {
        // 创建画布
        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext('2d');
        // 以图片为背景剪裁画布
        ctx.drawImage(image, 0, 0, image.width, image.height);
        // 获取图片后缀名
        const extension = image.src.substring(image.src.lastIndexOf('.') + 1).toLowerCase();
        // 某些图片 url 可能没有后缀名，默认是 png
        return canvas.toDataURL('image/' + extension, 1);
    },
    downLoad1(downloadName, url) {
    const tag = document.createElement('a');
    // 此属性的值就是下载时图片的名称，注意，名称中不能有半角点，否则下载时后缀名会错误
    tag.setAttribute('download', downloadName.replace(/\./g, '.'));

    const image = new Image();
    // 设置 image 的 url, 添加时间戳，防止浏览器缓存图片
    image.src = url + '?time=' + new Date().getTime();
    //重要，设置 crossOrigin 属性，否则图片跨域会报错
    image.setAttribute('crossOrigin', 'Anonymous');
    // 图片未加载完成时操作会报错
    image.onload = () => {
        tag.href = this.getImageDataURL(image);
        tag.click();
    };
},
    download() {  
      this.downLoad1('poster', this.posterPic)
      // this.getImageDataURL(this.posterPic)
      
      // let aLink = document.createElement('a');
      // let evt = document.createEvent("HTMLEvents");
      // evt.initEvent("click", true, true);
      // aLink.href = this.posterPic; 
      // aLink.download = 'poster.png';
      // aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));//兼容火狐
    },
    //下载
    downloadFile(fileName, content) {
      let aLink = document.createElement('a');
      let blob = this.base64ToBlob(content);

      let evt = document.createEvent("HTMLEvents");
      evt.initEvent("click", true, true);
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);

      aLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));//兼容火狐
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,');
      let contentType = parts[0].split(':')[1];
      let raw = window.atob(parts[1]);
      let rawLength = raw.length;

      let uInt8Array = new Uint8Array(rawLength);

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], {type: contentType});
    },
    async getData() {
      this.isPcFlag = this.IsPc();
      this.clientWidth = window.clientWidth;
      // this.isAI = this.$route.params.ai == 0 ? true : false;
      // console.log(isAI);
      let OAIDARY = this.$route.params.appraisalno.split("-"); // 不符合 AIIOVGQT 符合 AIZ0A9L8 中检不符合 AI1RUMJ0 符合 AI7XSULH
      let OAID = "";
      if (OAIDARY.length > 1) {
        OAID = OAIDARY[0] + OAIDARY[1];
      } else {
        OAID = OAIDARY[0];
      }
      await fetchWpReportDetail({ OAID }).then((res) => {
        this.isError = true;
        if (res.errorMsg == "Success") {
          this.genuine = res.genuine;
          this.ifFake = res.genuine == "1" ? false : true;
          this.noAppraisal = res.genuine == "3" ? false : true; // false 为无法鉴别
          this.kindName = res.kindName;
          this.brandName = res.brandName;
          this.seriesName = res.seriesName;
          this.description = res.description;
          this.descriptionList.push(res.description.slice(0, 22));
          this.descriptionList.push(res.description.slice(21, 44));
          let lastText = `${res.description.slice(43, 55)}`;
          this.descriptionList.push(lastText);
          this.exteriorUrl = `data:image/png;base64,${res.exteriorUrl}`;
          this.OAID = res.OAID;
          this.precent = res.grade * 100; //综合评分
          this.posterPic = res.reportImageURL;
          console.log(this.ifFake, this.noAppraisal)
          res.SARecordList.forEach((item, index) => {
            this.SARecordList.push(item);
            // this.SARecordList.push(item);
          });
          while (this.SARecordList.length <= 5) {
            this.SARecordList.push({
              pointName: ''
            })
          }
          this.appraisalTime = res.appraisalTime.split(" ")[0].split("-");
          this.descList = this.description.split("\n");
        } else {
          this.isError = false;
        }
      });
      await this.createQrCode();
      this.painting = {
        width: `1254px`,
        height: `1920px`,
        background: "https://oss.turingsenseai.com/1634095646634913220.png",
        views: [
          {
            type: "text",
            text: this.brandName,
            css: {
              top: "905px",
              left: "330px",
              color: "#828393",
              fontSize: "40px",
            },
          },
          {
            type: "text",
            text: this.OAID,
            css: {
              top: "1007px",
              left: "330px",
              color: "#828393",
              fontSize: "40px",
            },
          },
          {
            type: "image",
            url: this.imgData,
            css: {
              top: "1450px",
              left: "900px",
              width: "220px",
              height: "220px",
            },
          },
        ],
      };
    },
    descShowMore(flag) {
      flag ? (this.showMore = false) : (this.showMore = true);
    },
    saveImage() {
      const link = document.createElement("a");

      link.download = "poster.png";
      link.href = this.posterPic;
      console.log(link);
      link.click();
    },
    savePic() {
      // 没啥用
      if (this.openError) {
        Toast.loading({
          message: "图片加载失败请刷新重试",
        });
      }

      // setTimeout(() => {
      // htmlToImage
      //   .toCanvas(this.$refs.image, {
      //     cacheBust: true,
      //     quality: 1,
      //     canvasWidth: 1080,
      //     canvasHeight: 1920,
      //   })
      //   .then((canvas) => {
      //     // this.posterPic = canvas.toDataURL();
      //     document.getElementById("demo").appendChild(canvas);
      //     this.posterPic = false;
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
      // }, 200);
    },
    // @opned执行savepic先生成整个海报再用海报渲染点击后下载
    // 直接保存到相册
    // 目前选用长按保存方案PC使用下载
    // fileDownload(imgdata) {
    //   let aLink = document.createElement("a");
    //   aLink.style.display = "none";
    //   aLink.download = "图灵鉴定.png";
    //   // aLink.href = this.posterPic;
    //   aLink.href = URL.createObjectURL(this.dataURLtoBlob(imgdata));
    //   // 触发点击-然后移除
    //   document.body.appendChild(aLink);
    //   aLink.click();
    //   document.body.removeChild(aLink);
    // },
    getBase64Image(url, callback) {
      this.eleLoading = true;
      let Img = new Image(),
        dataURL = "";
      // Math.random()
      Img.src = url + "?v=" + Math.random();
      Img.setAttribute("crossOrigin", "Anonymous");
      try {
        Img.onload = function() {
          let canvas = document.createElement("canvas"),
            width = Img.width,
            height = Img.height;
          canvas.width = width;
          canvas.height = height;
          canvas.getContext("2d").drawImage(Img, 0, 0, width, height);
          let quality = 0.1;
          dataURL = canvas.toDataURL("image/jpeg", quality);
          while (dataURL.length / 1024 > 150) {
            quality -= 0.01;
            dataURL = canvas.toDataURL("image/jpeg", quality);
          }
          this.eleLoading = false;
          return callback ? callback(dataURL) : null;
        };
      } catch (error) {
        this.openError = true;
      }
    },
    async createQrCode() {
      new QRCode(document.getElementById("zp-report-qrcode"), {
        text: `${HOST_ADDRESS()}zp-report/${this.$route.params.appraisalno}`, // 需要转换为二维码的内容
        // text: `${HOST_ADDRESS()}wallet`,
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: 1,
      });

      let canvas = document
        .getElementById("zp-report-qrcode")
        .getElementsByTagName("canvas");
      this.imgData = canvas[0].toDataURL("image/png");
    },

    IsPc() {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let i = 0; i < Agents.length; i++) {
        if (userAgentInfo.indexOf(Agents[i]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      return flag;
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(",");
      //注意base64的最后面中括号和引号是不转译的
      var _arr = arr[1].substring(0, arr[1].length - 2);
      var mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(_arr),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime,
      });
    },
    shareH5() {
      console.log("share");
    },
    test(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss">
// vant组件样式
.van-tabs__wrap {
  height: 70px !important;
  .van-tabs__nav {
    // display: inline-block;
    padding: 0;
    // width: 10%;
    .van-tab {
      padding: 0;
      margin-right: 40 * 2px;
      display: inline-block;
      color: #828393;
      text-align: center;
      .van-tab__text {
        font-size: 0.9em;
      }
    }
    // .van-tab:nth-last-child(2) {
    //   margin-right: 0;
    // }
    .van-tab--active {
      &::after {
        content: "";
        width: 0;
        position: absolute;
        top: 1.9em;
        left: 50%;
        height: 0;
        transform: rotate(90deg) translateY(16%);
        border-bottom: 1em solid #2a2a30;
        border-left: 0.3em solid #2a2a30;
      }
      padding-bottom: 0.2em;
      color: #2a2a30;
      font-weight: 500;
    }
  }
  .van-tabs__line {
    display: none;
  }
}
body {
  background: linear-gradient(270.23deg, #26262e 0.15%, #4d4d59 99.76%);
}
.pc-mark {
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  .van-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
// 遮罩层
.water-mark {
  position: fixed;
  width: 100%;
  max-width: 750px;
  height: 100%;
  z-index: 5;
}
.cant_indt {
  width: 100%;
  .no_title {
      // text-align: center;
      // margin-left: 20px;
      font-weight: 500;
    }
    .reason {
      display: flex;
      flex-direction: column;
      width: 94%;
      margin: 0 auto;
      color: #828393;
      font-weight: 400;
      p {
        line-height: 17 * 2px;
      }
    }
}

// 组件样式
.bodydiv {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 20px;
  font-size: 20px;
  // height: 100vh;
  z-index: 4;
  margin-bottom: 100px;
  p,
  span {
    font-size: 20px;
    display: inline-block;
  }
  .bottom-detail {
    margin-top: -1px;
    background-color: white;
    // border-radius: 20px;
    width: 100%;
    margin-bottom: 20px;
    z-index: 6;
    .no_title {
      // text-align: center;
      // margin-left: 20px;
      font-weight: 500;
    }
    .reason {
      display: flex;
      flex-direction: column;
      width: 94%;
      margin: 0 auto;
      color: #828393;
      font-weight: 400;
    }
    .detail_title,
    .detail_container {
      margin: 3% 4%;
      .tag {
      }
    }
    
    .detail_container {
      // .detail_point {
      //   font-size: 0.8em;
      // }
      .point_content {
        width: 100%;
        border-top: 1px solid RGB(240, 240, 245);
        .precent {
          position: relative;
          margin-top: 14%;
          .linear {
            width: 100%;
            height: 10px;
            background-color: #b3d9fc;
            background: linear-gradient(90deg, #557AFF 0%, #4642FF 6.41%, #FF5572 102.62%);
          }
          .position_text {
            width: 150px;
            position: absolute;
            top: -2.1em;
            transform: scale(0.8) translateX(-14%);
            font-weight: 700;
            font-size: 1em;
            white-space: nowrap;
          }
          .position {
            width: 0.2em;
            height: 18px;
            background-color: black;
            position: absolute;
          }
          .precent_tip {
            display: flex;
            justify-content: space-between;
            span {
              font-size: 0.9em;
              color: RGB(168, 168, 180);
            }
          }
        }
        .ponit_pic {
          position: relative;
          display: flex;
          align-items: center;
          flex-direction: row;
          margin: 20px 0;
          .picT,
          .picF {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            img {
              width: 265px;
              height: 265px;
            }
          }
          .picF {
            position: relative;
            .fake_mark {
              position: absolute;
              border: 1px solid red;
              z-index: 7;
              border-radius: 45px;
              width: 9%;
              height: 8%;
            }
          }
          .pic_markT {
            position: absolute;
            top: 0;
            z-index: 6;
            width: 60%;
            height: 94%;
          }
          .pic_markF {
            position: absolute;
            top: 0;
            z-index: 6;
            height: 3.5rem;
            width: 3.5rem;
          }
          img {
            width: 35%;
            height: 35%;
            background-color: black;
            object-fit: contain;
            margin-bottom: 10px;
          }
          .trueArea {
            position: absolute;
            background-color: rgba(0, 0, 0, 0);
          }
          .trueP {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .truePic {
              width: 60%;
              height: 60%;
              background-color: black;
              object-fit: contain;
              margin-bottom: 10px;
            }
          }
          p {
            color: RGB(181, 181, 181);
          }
        }
        .point_dsc {
          margin: 0 auto;
          width: 100%;
          margin-bottom: 30px;
          // border-radius: 15px;
          background-color: RGB(248, 248, 251);
          // border: 1px solid RGB(238, 238, 238);
          p {
            padding: 20px;
          }
        }
      }
    }
  }
  .ccic-top {
    width: 450px;
    // height: 20vh;
    position: relative;
    margin: 15px 0 45px 0;
    z-index: 4;
    img {
      width: 100%;
    }
  }
}
// 中检底部
.ccic-bottom {
  width: 100%;
  // height: 26vh;
  position: relative;
  z-index: 6;
  img {
    width: 100%;
  }
  // background-size: 100% 31vh;
  // background-image: url(https://oss.turingsenseai.com/1624005265917545236.png);
}
// 分享
.shaer_mark {
  width: 100%;
  position: relative;
}
.share {
  height: 89px;
  width: 100vw;
  background-color: white;
  position: fixed;
  bottom: 0;
  z-index: 6;
  max-width: 750px;
  display: flex;
  display: flex;
  justify-content: center;
  span {
    width: 94%;
    background-color: #2a2a30;
    color: #fff;
    display: inline-block;

    text-align: center;
  }
}
// 海报

.poster {
  .poster_title {
    width: 100%;
    height: 6vh;
    line-height: 6vh;
    background-color: #f7f7f7;
    color: #363636;
    span {
      font-size: 1.1em;
      margin-left: 2%;
    }
  }
  // .poster_container {
  //   // width: 100%;
  //   // display: flex;
  //   // justify-content: center;
  //   // align-items: center;
  //   overflow: scroll;
  //   width: 73%;
  //   margin: 0 auto;
  //   margin-top: 2vh;
  //   display: flex;
  //   align-items: center;
  //   .back_img {
  //     // transform: translate(2vh, 3vh);
  //     width: 100%;
  //     background-repeat: no-repeat;
  //     .back_IMG {
  //       width: 73%;
  //       // height: 70vh;
  //       position: absolute;
  //       z-index: -1;
  //     }
  //     .isAI_mark {
  //       height: 14vh;
  //     }
  //     .back_title {
  //       font-size: 1.5em;
  //       font-weight: 600;
  //       color: #0a4074;
  //       display: inline-block;
  //       width: 100%;
  //       line-height: 14vh;
  //       text-align: center;
  //       // margin-bottom: 10px;
  //     }
  //     .poster_info {
  //       display: flex;
  //       justify-content: space-around;
  //       // align-items: center;
  //       // margin-bottom: 2vh;
  //       .poster_item {
  //         display: flex;
  //         flex-direction: column;
  //         div {
  //           display: flex;
  //           // align-items: center;
  //           margin-bottom: 20px;
  //           span {
  //             font-size: 0.9em;
  //             // margin-right: 10px;
  //           }
  //           p {
  //             font-size: 0.9em;
  //             color: #9a9ba8;
  //           }
  //         }
  //       }
  //     }
  //     .poster_img {
  //       // width: 25%;
  //       // height: 25%;
  //     }
  //     .poster_desc {
  //       width: 85%;
  //       // margin-left: 17px;
  //       span {
  //         display: inline-block;
  //         font-size: 1em;
  //         margin-bottom: 5px;
  //       }
  //       // p {
  //       //   // font-size: 0.9em;
  //       //   // height: 10vh;
  //       //   // line-height: 2.6vh;
  //       //   overflow: hidden;
  //       //   // text-overflow: ellipsis;
  //       //   // display: -webkit-box;
  //       //   // -webkit-line-clamp: 3;
  //       //   // -webkit-box-orient: vertical;
  //       //   color: #9a9ba8;
  //       // }
  //     }
  //     .bottom-icon {
  //       width: 100%;
  //     }
  //   }
  // }
  .downImg {
    // position: absolute;
    // margin-top: 50%;
    width: 73%;
    // top: 6vh;
    height: 60vh;
    // transform: translateY(-25%);
  }
  .save {
    background-color: #2a2a30;
    height: 6vh;
    border: none;
  }
  .van-icon {
    top: 3.5%;
    transform: translateY(-50%);
  }
}
.boswer_poster {
  .poster_title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    background-color: #f7f7f7;
    color: #363636;
    span {
      margin-left: 2%;
    }
  }
  .downImg {
    transform: translate(5vh, 5vh);
    height: 600px;
  }
  // .poster_container {
  //   width: 100%;
  //   height: 500px;
  //   // display: flex;
  //   // justify-content: center;
  //   // align-items: center;
  //   .back_img {
  //     transform: translate(7vh, 5vh);
  //     height: 500px;
  //     width: 75%;
  //     background-size: 100% 500px;
  //     background-repeat: no-repeat;
  //     .isAI_mark {
  //       height: 18%;
  //     }
  //     .back_title {
  //       color: #2d5c88;
  //       display: inline-block;
  //       width: 100%;
  //       line-height: 14vh;
  //       text-align: center;
  //       font-size: 18px;
  //     }
  //     .poster_info {
  //       display: flex;
  //       justify-content: space-around;
  //       align-items: center;
  //       // margin-bottom: 1vh;
  //       .poster_item {
  //         display: flex;
  //         flex-direction: column;
  //         div {
  //           display: flex;
  //           align-items: center;
  //           // margin-bottom: 5px;
  //           span,
  //           p {
  //             font-size: 0.2em;
  //           }
  //           span {
  //             margin-right: 10px;
  //           }
  //           p {
  //             color: #9a9ba8;
  //           }
  //         }
  //       }
  //     }
  //     .poster_img {
  //       background-size: 25% 25%;
  //     }
  //     .poster_desc {
  //       width: 85%;
  //       margin: 0 auto;
  //       span {
  //         display: inline-block;
  //         font-size: 0.2rem;
  //         margin-bottom: 0.1rem;
  //       }
  //       p {
  //         font-size: 0.2em;
  //         line-height: 3.2em;
  //         overflow: hidden;
  //         // text-overflow: ellipsis;
  //         // display: -webkit-box;
  //         // -webkit-line-clamp: 4;
  //         // -webkit-box-orient: vertical;
  //         color: #9a9ba8;
  //       }
  //     }
  //   }
  // }
  .save {
    background-color: #2a2a30;
    height: 50px;
    border: none;
    border-radius: 0;
  }
  .van-icon {
    font-size: 28px;
    top: 4%;
    transform: translateY(-50%);
  }
}
.top-desc {
  // height: 373 * 2px;
  background-color: white;
  // border-radius: 20px;
  width: 94%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  .back-img {
    height: 290 * 2px;
  }
  .bus_info {
    background-color: rgb(255, 255, 255);
    z-index: 100;
  }
  .cant_indt {
    background-color: rgb(255, 255, 255);
    z-index: 100;
  }
  .desc_title {
    margin-top: 20px;
    box-sizing: border-box;
    // width: 25%;
    width: 100%;
    z-index: 10;
    display: flex;
    justify-content: center;

    img {
      width: 60%;
    }
  }
  .desc_result {
    // margin-top: 0.5em;
    position: relative;
    letter-spacing: 0.2em;
    img {
      width: 22%;
      position: absolute;
      z-index: 4;
    }
    p {
      font-size: 1.5em;
      color: black;
      letter-spacing: 2%;
      z-index: 4;
      position: relative;
    }
  }
  .desc_container {
    // margin-top: 40px;
    span {
      font-weight: 700;
      width: 140px;
      font-size: 0.9em;
    }
    .desc_info {
      display: flex;
      justify-content: space-between;
      margin-bottom: 14px;
      .info_item {
        width: 60%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        margin-bottom: 40px;
        p {
          width: 80%;
          font-size: 0.9em;
          color: #828393;
        }
        div {
          display: flex;
        }
      }
      .info_img {
        width: 280px;
        // height: 280px;
        position: relative;
        top: -30px;
        .img_mark {
          position: absolute;
          z-index: 6;
          top: 0;
        }
      }
    }
    .desc {
      display: flex;
      .label_container {
        width: 100%;
        text-align: justify;
        p {
          font-size: 0.9em;
        }
      }
    }
  }
  .more {
    margin: 10px 0;
    position: relative;
    z-index: 6;
    p {
      font-size: 0.9em;
      width: 100%;
      text-align: center;
      font-weight: 700;
      margin-right: 10px;
    }
  }
}
</style>
